<template>
  <div class="bargain-active-index">
    <!--搜索表单-->
    <div class="d-b-c">
      <div class="mb18"><el-button size="small" icon="el-icon-plus" type="primary" @click="addClick" v-if="role==0" v-auth="'/plus/logistics/lists/add'">添加物流中心</el-button></div>
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item>
          <el-input v-model="searchForm.search" placeholder="请输入物流中心名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="name" label="物流中心名称" width="120"></el-table-column>
          <el-table-column prop="showdata" label="管理区域" >
             <template slot-scope="scope">
              <div class="area-list">
                <span v-if="scope.row.citys.citys.length == cityCount">全国</span>
                <span v-else v-for="(province, index) in scope.row.showdata" :key="index" class="pr16">
                  {{ province.name }}
                  <template v-if="!province.isAllCitys">
                    (<span class="am-link-muted gray9">
                      <em v-for="(city, city_index) in province.citys" :key="city_index">
                        <span>{{ city.name }}</span><span v-if="(city_index + 1) < province.citys.length">、</span>
                      </em>
                    </span>)
                  </template>
                </span>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="status_text" label="状态" width="120"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button v-if="role<2" @click="managerClick(scope.row.logistics_id)" type="text" size="small">管理</el-button>
              <el-button v-if="role==0" @click="editsClick(scope.row.logistics_id)" type="text" size="small">编辑</el-button>
              <el-button v-if="role==0" @click="deleteClick(scope.row.logistics_id)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import LogisticsApi from '@/api/logistics.js';
export default {
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*搜索表单对象*/
      searchForm: {},
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 10,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*区域数据源*/
      options: [],
      /*区域数据源*/
      optionsMap: {},
      cityCount:0,
      role:0,
    };
  },
  created() {
    /*获取列表*/
    this.getData();
  },
  methods: {
    /*查询*/
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },

    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      LogisticsApi.logisticsList(Params, true)
        .then(res => {
          self.loading = false;
          self.tableData = res.data.list.data;
          self.totalDataNumber = res.data.list.total;
          self.role = res.data.role;

          //区域源数据
          self.options = res.data.arr;
          self.cityCount = res.data.cityCount;
          self.options.forEach(function(area) {
            self.optionsMap[area.value] = area;
          });
          for (let index = 0; index < self.tableData.length; index++) {
            let formData = self.tableData[index].formData;

            formData.forEach(function(form) {
              // 转换为整数型
              for (var key in form.citys) {
                if (form.citys.hasOwnProperty(key)) {
                  form.citys[key] = parseInt(form.citys[key]);
                }
              }
              self.tableData[index].citys =form;
              self.tableData[index].showdata = self.getShowData({
                province: form.province,
                citys: form.citys
              });
            });
          }
        })
        .catch(error => {});
    },

    // 格式化选中的区域id
    getShowData: function(checkedData) {
      var self = this;
      var formData = {};
      checkedData.province.forEach(function(provinceId) {
        var province = self.optionsMap[provinceId],
          citys = [],
          cityCount = 0;
        for (var cityIndex in province.children) {
          if (province.children.hasOwnProperty(cityIndex)) {
            var cityItem = province.children[cityIndex];
            if (self.inArray(cityItem.value, checkedData.citys)) {
              citys.push({
                id: cityItem.value,
                name: cityItem.label
              });
            }
            cityCount++;
          }
        }
        formData[province.value] = {
          id: province.value,
          name: province.label,
          citys: citys,
          isAllCitys: citys.length === cityCount
        };
      });
      return formData;
    },

        // 数组中是否存在指定的值
    inArray: function(val, array) {
        return array.indexOf(val) > -1;
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val;
      this.getData();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getData();
    },

    /*添加物流中心*/
    addClick() {
      this.$router.push({
        path:'/plus/logistics/lists/add',
        query: {
        }
      });
    },

    /*修改物流中心*/
    editsClick(e) {
      let self = this;
      this.$router.push({
        path: '/plus/logistics/lists/edit',
        query: {
          logistics_id: e
        }
      });
    },
    /* 物流中心管理 */
    managerClick(e){
      let self = this;
      this.$router.push({
        path: '/plus/logistics/manager/index',
        query: {
          logistics_id: e
        }
      });
    },

    /*删除物流中心*/
    deleteClick(e) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          LogisticsApi.deleteLogistics(
            {
              logistics_id: e
            },
            true
          )
            .then(data => {
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.getData();
            })
            .catch(error => {});
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/logistics/lists/index.vue